import React, { useState } from "react";
import { getRuta, simpleMessage } from "../../../../helpers/Helpers";
import moment from "moment/moment";
import {
  BotonGenerar,
  CampoFecha,
  FormularioSelector,
  SelectorGestor,
} from "../../../../components/reportes/selector";

const SelectorCobroDiario = () => {
  const [selectedFecha, setSelectedFecha] = useState(new Date());
  const [selectedGestor, setSelectedGestor] = useState("t");

  let ruta = getRuta();

  const verReport = () => {
    if (!moment(selectedFecha).isValid()) {
      simpleMessage("Seleccione una fecha válida", "error");
      return;
    }

    var params = `${selectedGestor}/${moment(selectedFecha).format(
      "YYYY-MM-DD"
    )}`;
    window.open(`${ruta}/r-cobrodiario/${params}`);
  };

  return (
    <FormularioSelector>
      <SelectorGestor value={selectedGestor} onChange={setSelectedGestor} />

      <CampoFecha
        label="Seleccione una Fecha"
        value={selectedFecha}
        onChange={setSelectedFecha}
      />

      <BotonGenerar onClick={verReport} />
    </FormularioSelector>
  );
};

export default SelectorCobroDiario;
